import React, {useEffect, useRef, useState} from 'react';

// 그래프 기본 설정
const GUIDE_LINE_COUNT = 4;
const GRAPH_HEIGHT = 160;
const SVG_PADDING = {left: 0, right: 0, top: 50, bottom: 30};

export interface SvgGraphProps {
  height?: number;
  guideLineCount?: number;
  description?: string;
}

function DailyLineGraphError({height = GRAPH_HEIGHT, guideLineCount = GUIDE_LINE_COUNT}: SvgGraphProps) {
  const svgRef = useRef<SVGSVGElement>(null);
  const [width, setWidth] = useState(window.innerWidth - 90);

  useEffect(() => {
    function adjustSvgWidth() {
      if (svgRef.current) {
        setWidth(window.innerWidth - 90);
      }
    }

    window.addEventListener('resize', adjustSvgWidth);
    return () => {
      window.removeEventListener('resize', adjustSvgWidth);
    };
  }, []);

  return (
    <svg
      id="chart"
      ref={svgRef}
      preserveAspectRatio="xMinYMin meet"
      width={'100%'}
      height={height}
    >
      {/* X,Y축 설정*/}
      <line
        data-name="xAxios"
        x1={SVG_PADDING.left}
        y1={height - SVG_PADDING.bottom}
        x2={width - SVG_PADDING.right}
        y2={height - SVG_PADDING.bottom}
        stroke={'var(--outline-low)'}
        strokeWidth={1}
      ></line>
      <line
        data-name="yAxios"
        x1={SVG_PADDING.left}
        y1={height - SVG_PADDING.bottom}
        x2={SVG_PADDING.left}
        y2={SVG_PADDING.top}
        strokeWidth={1}
      ></line>

      {/* Y축 가이드라인 */}
      {Array.from({length: guideLineCount}, (_, index) => index).map((_, index) => (
        <line
          key={index}
          data-name="y-line"
          x1={SVG_PADDING.left}
          y1={(height - SVG_PADDING.bottom - SVG_PADDING.top) * (index / guideLineCount) + SVG_PADDING.top}
          x2={width - SVG_PADDING.right}
          y2={(height - SVG_PADDING.bottom - SVG_PADDING.top) * (index / guideLineCount) + SVG_PADDING.top}
          stroke={'var(--outline-low)'}
          strokeWidth={1}
          strokeDasharray={'3,3'}
        ></line>
      ))}
    </svg>
  );
}

export default DailyLineGraphError;
